"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.globalHeaderStyles = exports.StyledHeaderFooter = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _tachyons = require("../../framework/tachyons");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var globalHeaderStyles = function globalHeaderStyles(isBusy) {
  return (0, _styledComponents.createGlobalStyle)([".CenteredList{overflow:auto;}.MessageBar,.Header3{display:", ";}"], isBusy ? 'none' : 'block');
};

exports.globalHeaderStyles = globalHeaderStyles;

var StyledHeaderFooter = _styledComponents["default"].div.withConfig({
  displayName: "ThdHeaderFooterstyles__StyledHeaderFooter",
  componentId: "sc-1ibk7re-0"
})(["height:177px;", "{height:143px;}", ""], _tachyons.breakpoints.l, function (_ref) {
  var busy = _ref.busy;
  return busy ? (0, _styledComponents.css)(["display:block;"]) : (0, _styledComponents.css)(["display:none;"]);
});

exports.StyledHeaderFooter = StyledHeaderFooter;